module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Cargo Carrier","alternativeTitle":"Tractor","failedToFetch":"Failed to fetch cargo carriers"},"no":{"title":"Lastebærer","alternativeTitle":"Trekker","failedToFetch":"Kunne ikke hente lastebærere"}}')
  delete Component.options._Ctor
}
